import ChildrenCard from './src/ChildrenCard.vue'

ChildrenCard.install = function (Vue) {
  Vue.component(ChildrenCard.name, ChildrenCard)
}

export default ChildrenCard
